import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExecutionService } from '../service/execution.service';
import { CommonService } from '../service/common.service';
import { AppGenMainComponent } from '../app-gen-main/app-gen-main.component';

@Component({
  selector: 'app-app-gen-dialog',
  templateUrl: './app-gen-dialog.component.html',
  styleUrls: ['./app-gen-dialog.component.scss'],
})
export class AppGenDialogComponent implements OnInit {
  @ViewChild(AppGenMainComponent) appGenMain: AppGenMainComponent;
  formId: any;
  appId: any;
  formVersionId: any;
  componentName: string;
  commonService: CommonService;
  constructor(
    public dialogRef: MatDialogRef<AppGenDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any
  ) {}

  ngOnInit(): void {
    this.componentName = this.modalData.className;
    this.commonService = this.modalData?.commonService;
    //this.appGenMain.commonService.setAppGenTransData(this.modalData.appRefId);
  }

  onNoClick(): void {
    const transId =
      this.appGenMain?.commonService?.getTransData() ||
      this.modalData?.appRefId;
    const formObj = this.appGenMain?.commonService?.getTransFormData();
    /* this.appGenMain?.commonService?.setAppGenTransData(undefined);
    this.appGenMain?.commonService?.setAppGenTransFormData(undefined); */
    let isUpdate = true;
    if (!formObj) {
      isUpdate = false;
    }
    let placeholderMap = this.appGenMain?.commonService?.getEntityAttributeMapData(
      this.appGenMain?.commonService?.resultObj,
      this.appGenMain?.appGenServiceService?.getAppGenData(
        this.formId,
        this.appGenMain?.commonService?.tid
      ),
      true,
      false,
      false,
      false,
      false
      //"dd MMMM yyyy"
    );
    let plmap = this.appGenMain?.commonService?.getEntityAttributeMapData(
      this.appGenMain?.commonService?.resultObj,
      this.appGenMain?.appGenServiceService?.getAppGenData(
        this.formId,
        this.appGenMain?.commonService?.tid
      ),
      true,
      false,
      false,
      false,
      true
      //"dd MMMM yyyy"
    );
    console.log('***********', placeholderMap);
    console.log('**********', plmap);
    this.dialogRef.close({
      eventId: transId,
      formData: formObj,
      isUpdateRowData: isUpdate,
      placeholderMap: placeholderMap,
      plmap: plmap,
    });
  }
  getChckLstComponentData($event) {}
}
